import { http } from 'app';

export const getDocGeneratorLoginCode = async (): Promise<string> => {
  const response = await http.post<{ code: string }>('/doc-generator/auth/code', {});
  return response.data.code;
};
